<script>
import { defineComponent } from 'vue'
import MarkdownBlock from './MarkdownBlock.vue'
export default defineComponent({
  name: 'CookieBanner',
  components: { MarkdownBlock },
  props: {
    text: {
      type: String,
      default () {
        return 'This website uses cookies to ensure you get the best experience on our website. [Learn more](http://cookiesandyou.com/)'
      }
    }
  },
  emits: ['accepted']
})
</script>

<template>
  <div class="cookie-banner">
    <MarkdownBlock :text="text" tag="span" inline class="cookie-banner-text" />
    <div class="flex-grow" />
    <button class="cookie-banner-accept-button" @click="$emit('accepted', true)">
      <slot name="button">Got It!</slot>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  padding: 1rem 2rem;
  background-color: rgb(122, 146, 129);
}

.flex-grow {
  flex: 1 auto;
}
</style>
